export const validateEDeliveryAddress = (address: string) => {
  return String(address).match(/^AE:PL([a-zA-Z\-0-9]+)$/);
};
